<template><section><h2>基础坐标轴</h2>
<p>坐标轴组件会自己根据 chart 的 source 数据进行 layout 计算，并且进行默认布局，也会根据 chart 中的 visual 进行适配</p>
<block-demo tip="基础坐标" source="const data = [
  { month: &#39;Jan&#39;, city: &#39;London&#39;, value: 3.9 },
  { month: &#39;Feb&#39;, city: &#39;London&#39;, value: 4.2 },
  { month: &#39;Mar&#39;, city: &#39;London&#39;, value: 5.7 },
  { month: &#39;Apr&#39;, city: &#39;London&#39;, value: 8.5 },
  { month: &#39;May&#39;, city: &#39;London&#39;, value: 11.9 },
  { month: &#39;Jun&#39;, city: &#39;London&#39;, value: 15.2 }
]

const { Chart, Axis } = qcharts

const chart = new Chart({
  container: &#39;#app&#39;,
  size: [&#39;100%&#39;, &#39;100%&#39;]
}).source(data, {
  row: &#39;city&#39;,
  value: &#39;value&#39;,
  text: &#39;month&#39;
})

let xAxis = new Axis({ orient: &#39;bottom&#39; })
let yAxis = new Axis({ orient: &#39;left&#39; })

chart.append(xAxis).add(yAxis)
"><pre v-pre><code v-pre class="language-javascript"><span class="hljs-keyword">const</span> data = [
  { <span class="hljs-attr">month</span>: <span class="hljs-string">'Jan'</span>, <span class="hljs-attr">city</span>: <span class="hljs-string">'London'</span>, <span class="hljs-attr">value</span>: <span class="hljs-number">3.9</span> },
  { <span class="hljs-attr">month</span>: <span class="hljs-string">'Feb'</span>, <span class="hljs-attr">city</span>: <span class="hljs-string">'London'</span>, <span class="hljs-attr">value</span>: <span class="hljs-number">4.2</span> },
  { <span class="hljs-attr">month</span>: <span class="hljs-string">'Mar'</span>, <span class="hljs-attr">city</span>: <span class="hljs-string">'London'</span>, <span class="hljs-attr">value</span>: <span class="hljs-number">5.7</span> },
  { <span class="hljs-attr">month</span>: <span class="hljs-string">'Apr'</span>, <span class="hljs-attr">city</span>: <span class="hljs-string">'London'</span>, <span class="hljs-attr">value</span>: <span class="hljs-number">8.5</span> },
  { <span class="hljs-attr">month</span>: <span class="hljs-string">'May'</span>, <span class="hljs-attr">city</span>: <span class="hljs-string">'London'</span>, <span class="hljs-attr">value</span>: <span class="hljs-number">11.9</span> },
  { <span class="hljs-attr">month</span>: <span class="hljs-string">'Jun'</span>, <span class="hljs-attr">city</span>: <span class="hljs-string">'London'</span>, <span class="hljs-attr">value</span>: <span class="hljs-number">15.2</span> }
]

<span class="hljs-keyword">const</span> { Chart, Axis } = qcharts

<span class="hljs-keyword">const</span> chart = <span class="hljs-keyword">new</span> Chart({
  <span class="hljs-attr">container</span>: <span class="hljs-string">'#app'</span>,
  <span class="hljs-attr">size</span>: [<span class="hljs-string">'100%'</span>, <span class="hljs-string">'100%'</span>]
}).source(data, {
  <span class="hljs-attr">row</span>: <span class="hljs-string">'city'</span>,
  <span class="hljs-attr">value</span>: <span class="hljs-string">'value'</span>,
  <span class="hljs-attr">text</span>: <span class="hljs-string">'month'</span>
})

<span class="hljs-keyword">let</span> xAxis = <span class="hljs-keyword">new</span> Axis({ <span class="hljs-attr">orient</span>: <span class="hljs-string">'bottom'</span> })
<span class="hljs-keyword">let</span> yAxis = <span class="hljs-keyword">new</span> Axis({ <span class="hljs-attr">orient</span>: <span class="hljs-string">'left'</span> })

chart.append(xAxis).add(yAxis)
</code></pre>
</block-demo></section></template><script>export default {components:{}}</script>